import { UmbracoTypes } from '~/lib/data-contract';
import { ModuleContext } from './context/ModuleContext';
import { Blocks } from './types';

import M10Hero from './components/M10Hero';
import M11HeroSplit from './components/M11HeroSplit';
import M20Categories from './components/M20Categories';
import M21ReferencedCategories from './components/M21ReferencedCategories';
import PopularProductCarousel from './components/M30ProductCarousel/PopularProductCarousel';
import PopularProductCampaignCarousel from './components/M30ProductCarousel/PopularProductCampaignCarousel';
import BrandProductCarousel from './components/M30ProductCarousel/BrandProductCarousel';
import SpecificProductNumbersCarousel from './components/M30ProductCarousel/SpecificProductNumbersCarousel';
import CampaignProductCarousel from './components/M30ProductCarousel/CampaignProductCarousel';
import M45BrandOverview from './components/M45BrandOverview/BrandOverview';
import M60USP from './components/M60USP';
import M70Media from './components/M70Media';
import M75MediaText from './components/M75MediaText';
import M75TinyMediaText from './components/M75TinyMediaText';
import M76ContentPromotion from './components/M76ContentPromotion';
import M77SpecificProductNumbersGrid from './components/M77SpecificProductNumbersGrid';
import M80MediaTextBundle from './components/M80MediaTextBundle';
import M100RichText from './components/M100RichText';
import M110Tally from './components/M110Tally';
import M110TallySplit from './components/M110TallySplit';
import M120Accordion from './components/M120Accordion';
import DynamicCategoryListBlock from './components/DynamicCategoryListBlock';
import M200OrderHistory from './components/M200OrderHistory';
import M201OrderDetails from './components/M201OrderDetails';
import M202AccountInformation from './components/M202AccountInformation';
import M203AccountStatement from './components/M203AccountStatement';
import M204UserList from './components/M204UserList';
import M205UserProfile from './components/M205UserProfile';

const blocks: Blocks = {
    m10HeroModule: M10Hero,
    m11HeroSplitModule: M11HeroSplit,
    m20CategoriesModule: M20Categories,
    m21ReferencedCategoriesModule: M21ReferencedCategories,
    m30PopularProductCarouselModule: PopularProductCarousel,
    m30PopularProductCampaignCarouselModule: PopularProductCampaignCarousel,
    m30BrandProductCarouselModule: BrandProductCarousel,
    m30SpecificProductNumbersCarouselModule: SpecificProductNumbersCarousel,
    m30CampaignProductCarouselModule: CampaignProductCarousel,
    brandPicker: M45BrandOverview,
    m60UspModule: M60USP,
    m70MediaModule: M70Media,
    m75MediaAndTextModule: M75MediaText,
    m75TinyMediaAndTextModule: M75TinyMediaText,
    m76ContentPromotionModule: M76ContentPromotion,
    m77SpecificProductNumbersGridModule: M77SpecificProductNumbersGrid,
    m80MediaAndTextBundleModule: M80MediaTextBundle,
    m100RichTextModule: M100RichText,
    m110TallyModule: M110Tally,
    m110TallySplitModule: M110TallySplit,
    m120AccordionListModule: M120Accordion,
    DynamicCategoryListBlock: DynamicCategoryListBlock,
    m200OrderHistory: M200OrderHistory,
    m201OrderDetails: M201OrderDetails,
    m202AccountInfo: M202AccountInformation,
    m203AccountStatement: M203AccountStatement,
    m204UserList: M204UserList,
    m205UserProfile: M205UserProfile,
};

function Block({ element, hasGutter }: { element: UmbracoTypes.IModules; hasGutter?: boolean }) {
    const Block = blocks[element.type as keyof Blocks] || Noop;
    return <Block {...(element as object)} hasGutter={hasGutter} />;
}

function Noop({ children }: { children: React.ReactNode }) {
    return <>{children}</>;
}

export default function DynamicBlocks({
    elements,
    hasGutter = true,
}: {
    elements: UmbracoTypes.IModules[] | undefined;
    hasGutter?: boolean;
}) {
    return (
        <>
            {elements
                ? elements.map((element, index) => (
                      <ModuleContext.Provider value={{ index }} key={element.id || index}>
                          <Block element={element} hasGutter={hasGutter} />
                      </ModuleContext.Provider>
                  ))
                : null}
        </>
    );
}
